import type { Order } from "../../../../../../../services";

interface CallStatus {
	status?: "need_call" | "called" | "calling" | "none" | string;
	metadata?: { callerCallSign?: string };
	user?: { data?: { callSign?: string } };
}

const cellProcessing = (
	item: Order.Model,
): { content: string; backgroundColor?: string } => {
	const callStatus: CallStatus | undefined = (item as any).customerCallStatus;

	let content = "";
	if (callStatus?.status !== "need_call") {
		content =
			callStatus?.metadata?.callerCallSign ??
			callStatus?.user?.data?.callSign ??
			"";
	}

	let backgroundColor: string | undefined;
	switch (callStatus?.status) {
		case "need_call":
			backgroundColor = "#ADD7E7";
			break;
		case "called":
			backgroundColor = "#007F01";
			break;
		case "calling":
			backgroundColor = "#FFA500";
			break;
		case "none":
			backgroundColor = "#fa0213";
			break;
		default:
			backgroundColor = undefined;
	}

	return { content, backgroundColor };
};

export default cellProcessing;
